import { useEffect, useState } from "react";
import { ReactComponent as Bulb } from "@assets/images/bulb.svg";
import { ReactComponent as Estimated } from "@assets/images/Estimated.svg";
import { useTranslation } from "react-i18next";
import { FormControl, MenuItem, Select } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { getFoodData } from "data/uiData/CardsData/getFoodPreparingData";
import GridCards from "@components/ui/GridCards";
const FoodPreparingAdvice = ({ adviceList, day }) => {
  const [selectedDay, setSelectedDay] = useState(day);
  const { t } = useTranslation();
  const sortedAdviceArray = Object.entries(adviceList || {}).sort(
    ([, a], [, b]) => {
      return new Date(a.date) - new Date(b.date);
    }
  );

  const sortedAdviceObject = Object.fromEntries(sortedAdviceArray);
  useEffect(() => {
    setSelectedDay(day);
  }, [day]);

  const data = getFoodData(sortedAdviceObject[selectedDay]?.details, t);

  return (
    <div className="bg-white shadow-lg p-6 rounded-lg w-full max-w-full bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-[600] text-[#fff] text-[18px] md:text-[20x] font-[Lato]">
          {t(`dietPlanDashboard.foodPreparingAdvice.heading`)}
        </h2>
        <FormControl sx={{ minWidth: 120 }}>
          <Select
            value={selectedDay}
            onChange={(e) => setSelectedDay(e.target.value)}
            IconComponent={KeyboardArrowDown}
            sx={{
              borderRadius: "50px",
              backgroundColor: "white",
              "& .MuiSelect-select": {
                padding: "8px 16px",
                paddingRight: "32px !important",
                color: "#0575E6",
                fontSize: "16px",
                fontWeight: 500,
                textAlign: "center",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "& .MuiSvgIcon-root": {
                color: "#0575E6",
                right: "8px",
              },
            }}
          >
            {Object.keys(sortedAdviceObject).map((day) => (
              <MenuItem
                key={day}
                value={day}
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#0575E6",
                  "&:hover": {
                    backgroundColor: "rgba(5, 117, 230, 0.1)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(5, 117, 230, 0.2)",
                  },
                }}
              >
                {t(`days.${day.toLocaleLowerCase()}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <>
        <div className="border rounded-[17px] p-2 md:p-4 bg-white font-[Lato]">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <div className="text-[#fff] cursor-default text-[12px] md:text-[16px] font-[600] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content]">
              <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                <Bulb />
              </p>{" "}
              {t(`dietPlanDashboard.foodPreparingAdvice.tipHeading`)}
            </div>
            <p className="text-[#0575E6]  text-[11px] md:text-[14px] border border-dashed border-[#868686] p-2">
              <span className="text-[#535862] font-[400] text-[12px] md:text-[16px] flex items-center gap-2">
                <Estimated />{" "}
                {t(`dietPlanDashboard.foodPreparingAdvice.estimatedTime`)}:{" "}
                <span className="text-[#7B7B7B] text-[12px] md:text-[16px]">
                  {sortedAdviceObject[selectedDay]?.time}
                </span>
              </span>
            </p>
          </div>

          <p className="text-[14px] md:text-[18px] font-[500] font-[Lato] text-[#898787] mt-2">
            {sortedAdviceObject?.[selectedDay]?.tip}
          </p>
        </div>
        <GridCards
          data={data}
          className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3"
        />
      </>
    </div>
  );
};

export default FoodPreparingAdvice;
